import { useState, useEffect, useRef } from 'react';
import { CryptoWebSocket } from '../services/websocket';

let websocketInstance: CryptoWebSocket | null = null;
let activeSubscribers = 0;

export function useCryptoWebSocket() {
  const [price, setPrice] = useState<number | null>(null);
  const [isConnected, setIsConnected] = useState(false);
  const mountedRef = useRef(true);

  useEffect(() => {
    activeSubscribers++;

    if (!websocketInstance) {
      websocketInstance = new CryptoWebSocket();
    }

    const unsubscribe = websocketInstance.addSubscriber((data) => {
      if (mountedRef.current && data.price) {
        setPrice(data.price);
        setIsConnected(true);
      }
    });

    return () => {
      mountedRef.current = false;
      unsubscribe();
      activeSubscribers--;

      if (activeSubscribers === 0) {
        websocketInstance?.disconnect();
        websocketInstance = null;
      }
    };
  }, []);

  return { price, isConnected };
}